import { isStockReminderDue } from "./stock.js";

function productIdentity(item) {
  const barcode = String(item.barcode ?? "").replace(/\D/g, "");
  if (barcode) return `barcode:${barcode}`;
  return `name:${String(item.productName ?? "").trim().toLowerCase()}|${String(item.brand ?? "").trim().toLowerCase()}`;
}

/**
 * Builds one recommendation per retained product. Active stock takes priority
 * over used history and multiple active packs are counted together.
 * @param {Array<Record<string, any>>} items
 * @returns {Array<Record<string, any>>}
 */
export function buildRecommendations(items) {
  const groups = new Map();
  for (const item of items) {
    const key = productIdentity(item);
    groups.set(key, [...(groups.get(key) ?? []), item]);
  }

  const recommendations = [];
  for (const records of groups.values()) {
    const ordered = [...records].sort((left, right) => String(right.updatedAt ?? "").localeCompare(String(left.updatedAt ?? "")));
    const active = ordered.filter((item) => item.status === "ACTIVE");
    if (active.length) {
      const current = ordered.find((item) => item.status === "ACTIVE" || item.status === "CONSUMED");
      const totalQuantity = active.reduce((total, item) => total + Number(item.quantity || 0), 0);
      if (!current.recommendationDismissed && isStockReminderDue(totalQuantity, current.minimumQuantity)) {
        recommendations.push({ ...current, quantity: Number(totalQuantity.toFixed(2)), recommendationReason: "low-stock" });
      }
      continue;
    }

    const current = ordered[0];
    if (current?.status === "CONSUMED" && !current.recommendationDismissed) {
      recommendations.push({ ...current, recommendationReason: "used-up" });
    }
  }

  return recommendations.sort((left, right) => String(right.updatedAt ?? "").localeCompare(String(left.updatedAt ?? "")));
}
